import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IReturnListHistoryModel } from '../models/models'

export class GetOrderReturnHistoryApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/orderReturn/listHistoryById',
      requesterInfo,
    })
  }

  public async getOrderReturnHistory(request: number): Promise<IReturnListHistoryModel[]> {
    return await this.postAsync<IReturnListHistoryModel[]>(request)
  }
}
